<template>
  <div class="list-wrapper">
    <div v-for="(item, key) in items" :key="key" class="list-item__container" data-test-id="code-list-item">
      <div class="list-item__inner">
        <div class="list-item--color">
          <ColorDot :color="item.code.color" />
        </div>
        <div class="list-item--text">{{ item.code.name }}</div>
        <div v-if="item.code.occurrence !== undefined" class="list-item--counter" data-test-id="code-list-item__count">
          {{ item.code.occurrence }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { CodeAttachment } from '@/graphql/operations.gen';

export default defineComponent({
  name: 'CodeList',
  props: {
    items: {
      type: Array as PropType<Array<CodeAttachment>>,
      required: true,
    },
  },
});
</script>

<style lang="scss">
@use 'settings/colors';
@use 'mixins/typography';
.list-wrapper {
  display: flex;
  flex-direction: column;
  background: colors.$color-white;
  border: 1px solid colors.$color-grey-200;
  border-radius: 8px;
  padding: 8px 12px;
  width: 288px;
  max-height: 60vh;
  overflow-y: auto;
}
.list-item {
  &__container {
    display: block;
  }
  &__inner {
    display: grid;
    grid-template-columns: auto 1fr auto;
    align-items: center;
    gap: 4px;
    height: 32px;
  }

  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }

  &--text {
    @include typography.typography-14-normal();
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: colors.$color-grey-900;
  }

  &--counter {
    @include typography.typography-10-medium();
    background: colors.$color-grey-50;
    padding: 4px;
    border-radius: 100px;
    &__container {
      height: 100%;
    }
  }
}
</style>
